import { render, staticRenderFns } from "./TextAreaInput.vue?vue&type=template&id=4661b6de&scoped=true"
import script from "./TextAreaInput.vue?vue&type=script&lang=js"
export * from "./TextAreaInput.vue?vue&type=script&lang=js"
import style0 from "./TextAreaInput.vue?vue&type=style&index=0&id=4661b6de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4661b6de",
  null
  
)

export default component.exports